export interface CountryOption {
  code: string;
  name: string;
}

const fallbackCountries: CountryOption[] = [
  { code: "US", name: "United States" },
  { code: "GB", name: "United Kingdom" },
  { code: "FR", name: "France" },
  { code: "DE", name: "Germany" },
  { code: "ES", name: "Spain" },
  { code: "IT", name: "Italy" },
  { code: "CA", name: "Canada" },
  { code: "BR", name: "Brazil" },
  { code: "MU", name: "Maurice" },
  { code: "IN", name: "India" },
  { code: "CN", name: "China" },
  { code: "JP", name: "Japan" },
  { code: "SG", name: "Singapore" },
  { code: "AU", name: "Australia" },
  { code: "ZA", name: "South Africa" },
];

export function getCountryOptions(): CountryOption[] {
  try {
    const supportedValuesOf = (Intl as typeof Intl & { supportedValuesOf?: (key: string) => string[] }).supportedValuesOf;
    const supportedRegions = typeof supportedValuesOf === "function" ? supportedValuesOf("region") : [];
    const displayNames = new Intl.DisplayNames(["fr", "en"], { type: "region" });

    if (Array.isArray(supportedRegions) && supportedRegions.length > 0) {
      return supportedRegions
        .map((code) => ({ code, name: code === "MU" ? "Maurice" : displayNames.of(code) ?? code }))
        .filter((option) => option.name)
        .sort((a, b) => a.name.localeCompare(b.name));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn("Falling back to static country list", error);
  }

  return fallbackCountries;
}